import { create } from "zustand"

export const useAlertStore = create((set) => ({
  alert: { open: false, message: "", severity: "error", title: "Error" },
  showAlert: (payload) => set({ alert: { ...payload, open: true } }),
  closeAlert: () => set((state) => ({ alert: { ...state.alert, open: false } })),
}))